import { render, staticRenderFns } from "./FontExample.vue?vue&type=template&id=04b79398&scoped=true"
import script from "./FontExample.vue?vue&type=script&lang=js"
export * from "./FontExample.vue?vue&type=script&lang=js"
import style0 from "./FontExample.vue?vue&type=style&index=0&id=04b79398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b79398",
  null
  
)

export default component.exports